export default {
  defaultProps: {
    size: 'lg'
  }
}